import React from 'react';

interface MaximizedLayoutProps {
  children: React.ReactNode;
}

/**
 * A layout component that maximizes horizontal space usage
 * Wrap pages with this component to apply consistent horizontal maximization
 */
const MaximizedLayout: React.FC<MaximizedLayoutProps> = ({ children }) => {
  return (
    <div className="max-horizontal">
      <div className="page-content">
        {children}
      </div>
    </div>
  );
};

export default MaximizedLayout; 